import { CircularProgress } from '@mui/material';
import { ATSTabbedJobViewAutomationsTabTestIds } from 'data-testids/ATS';
import { SecondaryButton } from '../styles';
import { AutomationContentProps } from '../types';
import { HasAutomations } from './HasAutomations';

export const AutomationContent: React.FC<AutomationContentProps> = ({
  hasAutomations,
  isLoading,
  onOpenClick,
}) => {
  if (isLoading) {
    return <CircularProgress data-testid={ATSTabbedJobViewAutomationsTabTestIds.LOADING_SPINNER} />;
  }

  if (hasAutomations) {
    return <HasAutomations onOpenModal={onOpenClick} />;
  }

  return (
    <SecondaryButton
      data-testid={ATSTabbedJobViewAutomationsTabTestIds.CREATE_AUTOMATION_BUTTON}
      variant="outlined"
      onClick={onOpenClick}
      sx={{ width: '30%' }}
    >
      + Add an Automation
    </SecondaryButton>
  );
};
